import { getOrderApi } from '@/core/api/generatedApiClient';
import { rethrowHandledApiError } from '@/core/api/rethrowHandledApiError';
import type {
    CompleteOrderRequest,
    CreateOrderRequest,
    OrderResponse,
    UpdateOrderRequest,
} from '@/core/generated/api';

/** Выполняет операции с отдельным заказом */
export const orderService = {
    /** Начинает выполнение заказа оператором без создания трекера */
    async startOrderByAdmin(orderId: string): Promise<void> {
        try {
            await getOrderApi().startExecuteOrderByAdmin({ orderId });
        } catch (error: unknown) {
            return rethrowHandledApiError(error);
        }
    },

    /** Завершает заказ с текстом отчёта и фотографиями */
    async completeOrder(request: CompleteOrderRequest): Promise<void> {
        try {
            await getOrderApi().completeOrder({ completeOrderRequest: request });
        } catch (error: unknown) {
            return rethrowHandledApiError(error);
        }
    },

    /** Создаёт заказ и возвращает его данные */
    async createOrder(request: CreateOrderRequest): Promise<OrderResponse> {
        try {
            const response = await getOrderApi().createOrder({ createOrderRequest: request });

            return response.data;
        } catch (error: unknown) {
            return rethrowHandledApiError(error);
        }
    },

    /** Обновляет заказ и возвращает его данные */
    async updateOrder(request: UpdateOrderRequest): Promise<OrderResponse> {
        try {
            const response = await getOrderApi().updateOrder({ updateOrderRequest: request });

            return response.data;
        } catch (error: unknown) {
            return rethrowHandledApiError(error);
        }
    },

    /** Повторяет заказ и возвращает созданный заказ */
    async repeatOrder(orderId: string): Promise<OrderResponse> {
        try {
            const response = await getOrderApi().repeatOrder({ orderId });

            return response.data;
        } catch (error: unknown) {
            return rethrowHandledApiError(error);
        }
    },

    /** Возвращает заказ по его идентификатору */
    async getOrderById(id: string): Promise<OrderResponse> {
        try {
            const response = await getOrderApi().getById({ id });

            return response.data;
        } catch (error: unknown) {
            return rethrowHandledApiError(error);
        }
    },
};
